import { css, MsdkStyledComponent, styled, Typography, TypographyProps } from '@msdk/ui'

export const EllipsisStyle: ReturnType<typeof css> = css`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
`

export const Ellipsis: MsdkStyledComponent<TypographyProps> = styled(Typography)<TypographyProps>`
  ${EllipsisStyle}
`
